module.exports = __webpack_public_path__ + "static/img/ic_gy_d_e@2x.06ad1e90.png";